import React from 'react';
import HomePageHeader from '../HomePageHeader';
import Footer from '../HomePageFooter';
import ImageHeading from './ImageHeading';

const OurHistory = () => {

    const renderHistorySection = () => {
        return (
            <section className='legal pt-5 pb-5'>
                <div className='container'>
                    <div className="row">
                        <div className="pr-heading history">
                            <h1>
                                Our History
                            </h1>
                        </div>
                    </div>
                    <div className='row'>
                        <p>
                            St. Andrew’s College, Gorakhpur, named after Saint Andrew, one of the first twelve disciples of Jesus Christ, had a humble beginning in 1828 as a Mission School by the Church Missionary society to provide education primarily to Christian children but also to others irrespective of creed that voluntarily joined it.
                        </p>
                        <p>
                            The foundation of the Church Missionary Society (C.M.S.) in 1699 was consequential to the Evangelical Revival, with the role of great grandfather of Indian Evangelical Revival being ably played by the Rev. Charles Simeon. He was the Fellow of King's College and the Vicar of the Holy Trinity College, Cambridge.
                        </p>
                        <p>
                            Even while the Church was on the verge of becoming just a salutary maxim and devoid of consciousness of missionary obligations, he went about with his fiery zeal for the missionary enterprise in India. During the last decade of the 18th century, Rev.
                            Charles had the rare opportunity of influencing young potential zealots of the University towards a revival of missionary zeal.
                        </p>
                        <p>
                            Despite opposition by East India Company in direct missionary works in North India, he vented the innermost desires of his spiritual sons by making them chaplains of East India Company.
                            Initially in the first half of the 19th century, the C.M.S. founded schools to provide education to Christian children of Indian and European descent.
                            Later the need was felt to mold them on theological ramparts and thereafter prepare them to attain ministry.
                        </p>
                        <p>
                            The maxim gradually became. And the 1857 mutiny struck a heavy blow to the institutions of higher education, which survived nevertheless by the end of century, especially during the tenure of Lord Curzon.
                            It was in 1899, when a new impetus was given to the moribund state of development of Anglican Communion colleges in India.
                            Many colleges were established all across the country and as a result of it the missionaries got a fresh lease of life.
                            The names of some of these are Bishop's College, Calcutta, St. John's College, Agra, St. Paul's Cathedral College, Calcutta, St. Stephen's College, Delhi, Christ Church College, Kanpur, St. Andrew's College, Gorakhpur, St. Columbus College, Hazaribagh, Oxford and Cambridge Hostel, Allahabad, C.M.S. College, Kottayam, St. Paul's College, Palamcottah, Bishop Heber College, Trichinopoly, Nobel College, Maulipatam and Sarah Tucker College, Tamil Nadu.
                        </p>

                        <p className='text-bold w-100 mb-1'>Bishop's College, Calcutta:</p>
                        <p>Established on 15th December, 1820, it is a leading Theological College of the Church of North India (CNI) providing and producing distinguished Church leaders for the CNI.</p>
                        
                        <p className='text-bold w-100 mb-1'>St. John'sCollege, Agra:</p>
                        <p>Established in the year 1885, it is a postgraduate institution with facilities of Arts, Science and Commerce.</p>

                        <p className='text-bold w-100 mb-1'>St. Paul's Cathedral College, Calcutta (1865):</p>
                        <p>Established in 1865, it provides degree courses in Arts affiliated to the Calcutta University.</p>

                        <p className='text-bold w-100 mb-1'>St. Stephen's College, Delhi(1882):</p>
                        <p>Established in 1882, it is one of the pioneering institutes of India.</p>

                        <p className='text-bold w-100 mb-1'>Christ Church College, Kanpur:</p>
                        <p>It is a postgraduate academic institution Ewing Christian College, Allahabad It is another leading institution providing degree courses.</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <HomePageHeader />
            <ImageHeading heading='History' />
            {renderHistorySection()}
            <Footer />
        </>
    );
}

export default OurHistory;